// removed by extract-text-webpack-plugin
module.exports = {"line-break-mobile":"_3eUIt","lineBreakMobile":"_3eUIt","hero-content":"PxqwY","heroContent":"PxqwY"};